import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProgressReportGenerator = ({ child, onGenerate }) => {
  const reportOptions = [
    {
      id: 'weekly',
      title: 'Rapport Hebdomadaire',
      description: 'Activités et progression de la semaine dernière',
      icon: 'Calendar',
      color: 'blue'
    },
    {
      id: 'monthly',
      title: 'Rapport Mensuel',
      description: 'Synthèse complète du mois en cours',
      icon: 'FileText',
      color: 'green'
    },
    {
      id: 'comprehensive',
      title: 'Rapport Complet',
      description: 'Analyse détaillée depuis l\'inscription',
      icon: 'BookOpen',
      color: 'purple'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-50 border-blue-200 hover:border-blue-400',
    green: 'bg-green-50 border-green-200 hover:border-green-400',
    purple: 'bg-purple-50 border-purple-200 hover:border-purple-400'
  };

  const iconColors = {
    blue: 'text-blue-600',
    green: 'text-green-600',
    purple: 'text-purple-600'
  };

  return (
    <div className="bg-card rounded-xl p-6 border border-border shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="FileText" size={24} className="text-primary" />
        <h2 className="text-xl font-semibold text-foreground">
          Génération de Rapports
        </h2>
      </div>

      <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-200">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-blue-600 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-blue-900 mb-1">
              Rapports Personnalisés
            </p>
            <p className="text-xs text-blue-700">
              Générez des rapports détaillés sur la progression de {child?.name} pour suivre son parcours d'orientation.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {reportOptions?.map((option) => (
          <button
            key={option?.id}
            onClick={onGenerate}
            className={`w-full text-left p-4 rounded-lg border-2 transition-all duration-300 ${
              colorClasses?.[option?.color]
            }`}
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm">
                  <Icon
                    name={option?.icon}
                    size={24}
                    className={iconColors?.[option?.color]}
                  />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                  {option?.title}
                </h3>
                <p className="text-sm text-gray-600">{option?.description}</p>
              </div>
              <Icon name="Download" size={20} className="text-gray-400" />
            </div>
          </button>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900 mb-3">
          Options de Partage
        </h3>
        <div className="flex flex-wrap gap-3">
          <Button variant="outline" size="sm" iconName="Mail">
            Envoyer par Email
          </Button>
          <Button variant="outline" size="sm" iconName="Printer">
            Imprimer
          </Button>
          <Button variant="outline" size="sm" iconName="Share2">
            Partager
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProgressReportGenerator;